import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import Select from "react-select";
import { AvForm, AvField} from "availity-reactstrap-validation";
import { validateToken, has_Permission } from '../../../helpers/jwt-token-access/accessToken'
//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";

import { Button, Card, CardBody, Col, Container, Row, Label, Input, FormGroup, ModalHeader, Modal, ModalBody, Spinner } from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../../helpers/Baseurl"

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';


const ModuleTypeGroup = [
	{ 
		label: "Module Type",
		options: [
            { label: "Itinerary", value: "0" },
            { label: "Location", value: "1" },
            { label: "Vehicle", value: "2" },
            { label: "Hotel", value: "3" },
            { label: "Activity", value: "4" },
            { label: "Terms & Conditions", value: "5" },
            { label: "Inclusitions Exclusitions", value: "6" },
            { label: "Payments", value: "7" },
            { label: "Signatures", value: "8" },
            { label: "country", value: "9" },
            { label: "Users", value: "10" },
            { label: "Permissions", value: "11" },

		]
	}
];

const modules = ['Itinerary', 'Location', 'Vehicle', 'Hotel' ,'Activity', 'Terms & Conditions', 'Inclusitions Exclusitions',
                  'Payments', 'Signatures', 'country', 'Users', 'Permissions']

class UserRoles extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 11, 'read' )){
      this.props.history.push('/users')
    }
    this.state = {
      country_id:"",
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",

      countries: [],
      selected_role : null,
      selectedModule: { label: "Itinerary", value: "0" },
      breadcrumbItems : [
        { title : "Planmans", link : "/dashboard" },
        { title : "User Roles", link : "#" },
    ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleRoleClicks = this.handleRoleClicks.bind(this)
    this.tog_EditData = this.tog_EditData.bind(this)
    this.handleEdit = this.handleEdit.bind(this)
    this.handleEditRowSubmit = this.handleEditRowSubmit.bind(this)
  }

  tog_EditData() {
    this.setState(prevState => ({
        model_EditData: !prevState.model_EditData
    }));
    this.removeBodyCss();
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }
  async componentDidMount() {
 
    this.loadData();
 }

 async loadData(){

  const requestOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  await fetch(`${BaseUrl}/api/accounts/role/`,requestOptions)
      .then(res => res.json())
      .then(
          (data) => {
              this.setState({ countries: data  })
          },
          (error) => {
              console.log(error, 'error--------------') 
          }
      )  
 }

  handleRoleClicks = id => {   

    const requestOptions = {
      method: 'DELETE',
  
      };
        fetch(`${BaseUrl}/api/accounts/role/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    this.loadData();
                    this.setState({
                      country_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Country has been deleted."
                      })
                      
                      
                  }
              }
          )

  }

  handleEditRowSubmit(e, values){
    this.setState({editDataloading:true})
    const { selectedModule, selected_role } = this.state
    let data = {

        "name": values.name,
        "module": selectedModule.value,
        "read": document.getElementById('read').checked,
        "create": document.getElementById('create').checked,
        "edit": document.getElementById('edit').checked,
        "delete": document.getElementById('delete').checked,
    }
    console.log(data)
    if (selected_role){
        const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
        };
        fetch(`${BaseUrl}/api/accounts/role/${selected_role.id}/`, requestOptions)
        .then(res => 
            {if(res.status >= 400){
              res.json().then((resp) => {
                let error = resp['non_field_errors']
                if(error){
                  toastr.error("Role with Selected Module and Permissions already Created", "")
                }else{
                  toastr.error("Somthing Went Wrong", "")
                }
                this.tog_EditData()
                this.setState({editDataloading:false})
              })

            }
            else{
                this.loadData(); 
                this.tog_EditData()
                this.setState({editDataloading:false})    
            }
          }
        )

    }else{
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
        body: JSON.stringify(data)
        };
        fetch(`${BaseUrl}/api/accounts/role/`, requestOptions)
        .then(res => 
            {if(res.status >= 400){
              res.json().then((resp) => {
                let error = resp['non_field_errors']
                console.log(error, "-------------lkjljj")
                if(error){
                  toastr.error("Permissions with Selected Module already Created", "")
                }else{
                  toastr.error("Somthing Went Wrong", "")
                }
                this.tog_EditData()
                this.setState({editDataloading:false})
              })
              
            }
            else{
              res.json().then((resp) => {
                this.loadData()
                this.tog_EditData()
                this.setState({editDataloading:false})

              }) 
            }
          }
        )
    }
  }

    handleEdit = (row) => {
        let lable = { label: modules[parseInt(row.module)], value : parseInt(row.module)}
        this.setState({ selectedModule: lable, selected_role: row })
        this.tog_EditData()
    }

  render() {

    const { countries, selected_role } = this.state

    const { SearchBar } = Search

    //pagination customization
    let total_size = countries.length 
    const pageOptions = {
      sizePerPage: 30,
      totalSize: total_size, // replace later with size(Order),
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const countriesColumns = [
      {
        dataField: "id",
        text: "id",
        hidden: true,
      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cellContent, row) => (
            <Link to="#" onClick={() => this.handleEdit(row) } className="me-3 text-dark">{cellContent}</Link>
          ),
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        Style: { float: 'left', width:'10' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            {has_Permission(this.obj.user, 11, 'edit' )?
            <Link to="#" onClick={() => this.handleEdit(row) } className="me-3 text-primary"><i className="mdi mdi-pencil font-size-18"></i></Link>
            :null}
            {has_Permission(this.obj.user, 11, 'delete' )?
            <Link to="#" onClick={() => this.setState({ alert_confirm: true, country_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            :null}
            </React.Fragment>
        ),
      },
    ]
    
    return (
      <React.Fragment>
        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="All Permissions" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={countries}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={countries}
                          columns={countriesColumns}
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitProps.searchProps}
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                {has_Permission(this.obj.user, 11, 'create' )?
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => {this.tog_EditData(); this.setState({ selected_role: null })}}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      Add Role
                                    </Button>
                                  </div>
                                  :null}
                                </Col>
                              </Row>
                              <div className="table-responsive">

                                <BootstrapTable
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                />
                                
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                              {this.state.alert_confirm ? (
                                                    <SweetAlert
                                                    title="Are you sure?"
                                                    warning
                                                    showCancel
                                                    confirmBtnBsStyle="success"
                                                    cancelBtnBsStyle="danger"
                                                    onConfirm={() => this.handleRoleClicks(this.state.country_id)}
                                                    onCancel={() =>
                                                        this.setState({
                                                            alert_confirm: false,
                                                            country_id:"",

                                                        })
                                                    }
                                                    >
                                                    You won't be able to revert this!
                                                    </SweetAlert>
                                                ) : null}

                                               {this.state.success_confirm ? (
                                              <SweetAlert
                                              success
                                              title={this.state.dynamic_title}
                                              confirmBtnBsStyle="success"
                                              cancelBtnBsStyle="danger"
                                              onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                              >
                                                  {this.state.dynamic_description}
                                              </SweetAlert>
                                          )
                                          : null
                                      }
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
          <Col sm={6} md={4} xl={3} className="mt-4">
               
               <Modal
               isOpen={this.state.model_EditData}
               toggle={this.tog_EditData}
               centered={true}
               >
                   <ModalHeader toggle={() => this.tog_EditData()}>
                   {selected_role? `Edit ${selected_role.name}`: `Create Role`} 
                   </ModalHeader>
                   <ModalBody>
                       <AvForm className="needs-validation" onValidSubmit={this.handleEditRowSubmit} >

                        
                        <Row>
                            <Col md='6'>
                                <div className="mb-3">
                                    <Label className="form-label" htmlFor="name">Name</Label>
                                        <AvField
                                            name="name"
                                            placeholder="Name"
                                            type="text"
                                            errorMessage="Name"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                            id="name"
                                            value = {selected_role? selected_role.name: ""}
                                            
                                        />
                                </div>
                            </Col>
                            <Col md="6">
                                <div className="mb-3">
                                    <Label className="form-label">Module</Label>
                                    <Select 
                                        value = {this.state.selectedModule}
                                        onChange={(e)=> this.setState({ selectedModule : e })}
                                        options={ModuleTypeGroup}
                                        classNamePrefix="select2-selection"
                                    />
                                </div>
                            </Col>
                           
                        </Row>

                        <Row>
                          <Col md={6} className="mt-3">                      
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" defaultChecked={selected_role? selected_role.read:true} id="read" />
                                  <Label className="form-check-label" htmlFor="read">
                                      Read
                                  </Label>
                              </div>                 
                          </Col>
                          <Col md={6} className="mt-3">                         
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" defaultChecked={selected_role? selected_role.create:false} id="create" />
                                  <Label className="form-check-label" htmlFor="create">
                                  Create
                                  </Label>
                              </div>                   
                          </Col>
                          
                        </Row> 
                        <Row>
                          <Col md={6} className="mt-3">                      
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" defaultChecked={selected_role? selected_role.edit:false} id="edit" />
                                  <Label className="form-check-label" htmlFor="edit">
                                      Edit
                                  </Label>
                              </div>                 
                          </Col>
                          <Col md={6} className="mt-3">                         
                              <div className="form-check mb-3">
                                  <Input className="form-check-input" type="checkbox" defaultChecked={selected_role? selected_role.delete:false} id="delete" />
                                  <Label className="form-check-label" htmlFor="delete">
                                  Delete
                                  </Label>
                              </div>                   
                          </Col>
                          
                        </Row> 
               
                           
                                           
                           <FormGroup className="mb-0">
                           {this.state.editDataloading?(
                               <Spinner className="me-2 mt-2" color="primary" />
                           ):(
                               <div>
                           
                           <Button type="submit" color="primary" className="me-1">
                               Submit
                           </Button>
                           </div>
                               )}
                           </FormGroup>     
                       </AvForm>

                   </ModalBody>
               </Modal>
        </Col>
        </div>
      </React.Fragment>
    )
  }
}

export default UserRoles